import React from 'react';
import { Card } from './ui/card';
import { useLanguage } from '../context/LanguageContext';

const Partners = () => {
  const { t } = useLanguage();
  const partners = [
    {
      name: 'Ville de Dijon',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/ztvkfyq8_SLogo%20Dijon.svg.png',
      type: 'Partenaire Principal',
      link: 'https://www.dijon.fr/'
    },
    {
      name: 'Dijon Métropole',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/rwfaa91q_WhatsApp%20Image%202026-04-09%20at%2011.23.00.jpeg',
      type: 'Partenaire Principal',
      link: 'https://www.dijon-metropole.fr/'
    },
    {
      name: 'Conseil Régional Bourgogne-Franche-Comté',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/dn3uwp3y_SConseil%20re%CC%81gional%20logo.png',
      type: 'Partenaire Régional',
      link: 'https://www.bourgognefranchecomte.fr/'
    },
    {
      name: 'Conseil Départemental',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/o6cty2qg_SConseil%20departemntal%20logo.png',
      type: 'Partenaire Départemental',
      link: 'https://www.cotedor.fr/'
    },
    {
      name: 'Speed Solutions',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/0thwzyqe_speed%20solution%20.jpeg',
      type: 'Partenaire Technique',
      link: 'https://speed-solutions.fr/'
    },
    {
      name: 'CREPS BFC',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/00xswcs6_Slogocreps-blanc.png',
      type: 'Partenaire Formation',
      link: 'https://creps-bourgognefranchecomte.fr/'
    },
    {
      name: 'MJC Montchapet',
      logo: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/qaahw7q8_Slogo%20MJC.png',
      type: 'Partenaire Associatif',
      link: 'https://accueilmontchapet.wixsite.com/mjc-cs'
    },
    {
      name: 'Go Wok',
      logo: '/gowok_logo.png',
      type: 'Partenaire',
      link: 'https://www.gowok.fr/'
    },
    {
      name: 'Decathlon',
      logo: '/decathlon_logo.png',
      type: 'Partenaire',
      link: 'https://www.decathlon.fr/store-view/magasin-de-sports-dijon-quetigny-0070002800028'
    }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('partners_title')}
            </h2>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-6"></div>
            <p className="text-gray-400 text-lg">
              {t('partners_subtitle')}
            </p>
          </div>

          {/* Partners Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {partners.map((partner, index) => (
              <a
                key={index}
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visiter le site de ${partner.name}`}
                className="block cursor-pointer focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-black rounded-lg transition-all duration-300"
              >
                <Card
                  className="bg-zinc-800/50 backdrop-blur-sm border-zinc-700 hover:border-red-500 hover:shadow-lg hover:shadow-red-500/20 transition-all duration-300 hover:-translate-y-1 p-6 h-full"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-full h-24 flex items-center justify-center mb-4">
                      {partner.logo ? (
                        <img
                          src={partner.logo}
                          alt={partner.name}
                          className="max-w-full max-h-full object-contain"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-zinc-700/50 rounded-lg">
                          <span className="text-gray-400 text-sm text-center px-2">Logo à venir</span>
                        </div>
                      )}
                    </div>
                    <h3 className="text-lg font-bold text-white mb-2">{partner.name}</h3>
                  </div>
                </Card>
              </a>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <Card className="bg-zinc-800/30 backdrop-blur-sm border-zinc-700 p-8 md:p-12 inline-block">
              <h3 className="text-2xl font-bold text-white mb-4">
                {t('partners_become_title')}
              </h3>
              <p className="text-gray-400 mb-6 max-w-2xl">
                {t('partners_become_desc')}
              </p>
              <a
                href="mailto:asso.hmditeam@gmail.com"
                className="inline-block bg-red-500 hover:bg-red-600 text-white px-8 py-3 rounded-lg transition-colors duration-300 font-bold"
              >
                {t('partners_contact_btn')}
              </a>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
